import request from '@/util/request';
import qs from 'qs';

export const inspectProjectGetList = (params, options) =>
  request.get('/api/inspectProject/page', Object.assign({}, options, { params }));
export const getList = (params, options) =>
  request.get('/api/inspectProject/list', Object.assign({}, options, { params }));
export const inspectProjectGetDetail = (params, options) =>
  request.get('/api/inspectProject/detail', Object.assign({}, options, { params }));

export const inspectProjectRemove = (params, options) =>
  request.post('/api/inspectProject/remove', qs.stringify(params), options);

export const inspectProjectAdd = (params, options) =>
  request.post('/api/inspectProject/submit', params, options);

export const inspectProjectUpdate = (params, options) =>
  request.post('/api/inspectProject/submit', params, options);
